const verification_record = {
    not_found: 'Record di verifica non trovato.',
    permission_denied: 'Permesso negato, per favore riautenticati.',
    not_supported_for_google_one_tap: 'Questa API non supporta Google One Tap.',
};
export default Object.freeze(verification_record);
